import React, { Component } from 'react';
import { connect } from 'react-redux';
import MUIDataTable from 'mui-datatables';


import {
    getNewContract
} from 'Actions';


class NewContract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewdiv: true,
    };
  }

  componentDidMount() {
    this.props.getNewContract();
  }

  render() {
    const { newcontractlist, loading } = this.props;

    const options = {
      filterType: 'dropdown',
      rowsPerPage: 50,
      responsive:'standard',
      rowsPerPageOptions: [50, 100, 150],
      selectableRowsHideCheckboxes: true,
    };

    const columns = [
      { name: 'sno', label: 'SNO.' },
      { name: 'student', label: 'STUDENT' },
      { name: 'agreementtype', label: 'AGREEMENT TYPE' },
      { name: 'executiondate', label: 'EXECUTION DATE' },
      { name: 'startdate', label: 'AGREEMENT START DATE' },
      { name: 'enddate', label: 'AGREEMENT END DATE' },
    ];

    const tableData = newcontractlist.map((data,index) => {
      return {
        sno: index + 1,
        student: data.studentname,
        agreementtype: data.agreementtype,
        executiondate: data.exdate,
        startdate: data.stdate,
        enddate: data.eddate,
      };
    });
    return (
      <div className="saas-dashboard">
        {this.state.viewdiv && (
          <div className="col-sm-12 col-lg-12">
            <MUIDataTable
              data={tableData}
              columns={columns}
              options={options}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
    const { contractDashboard } = state;
    return {
        newcontractlist: contractDashboard.newcontractlist,
      loading: contractDashboard.loading,
    };
  };

  export default connect(mapStateToProps, {
    getNewContract,
  })(NewContract);

